module.exports = __webpack_public_path__ + "static/media/motorsports-icon.27a151f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/motorsports-icon.svg
// module id = 44
// module chunks = 0